import { FormattedMessage } from 'react-intl';

import {
  AveragePlayerScore,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useDefaultAverageScore } from '@sorare/core/src/hooks/useDefaultAverageScore';
import { fantasy, scoutingCenter } from '@sorare/core/src/lib/glossary';
import {
  PlayerSearchViewAttributes,
  StatsDisplay,
} from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

export const StatsDisplayToggle = () => {
  const defaultAverageScore = useDefaultAverageScore();
  const { sport } = useSportContext();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();

  const labels = {
    [Sport.FOOTBALL]: {
      on:
        defaultAverageScore ===
        AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE
          ? scoutingCenter.last15Total
          : scoutingCenter.last10Total,
      off: scoutingCenter.per90,
    },
    [Sport.BASEBALL]: {
      on: fantasy.total,
      off: scoutingCenter.perGame,
    },
    [Sport.NBA]: {
      on: fantasy.total,
      off: scoutingCenter.perGame,
    },
  };

  const statsDisplay = statsManager[PlayerSearchViewAttributes.STATS_DISPLAY];
  return (
    <TextSwitch
      value={statsDisplay}
      compact
      onChange={v =>
        updatePlayerSearchViewAttribute(
          PlayerSearchViewAttributes.STATS_DISPLAY,
          v
        )
      }
      options={[
        {
          label: <FormattedMessage {...labels[sport].on} />,
          value: StatsDisplay.TOTAL,
        },
        {
          label: <FormattedMessage {...labels[sport].off} />,
          value: StatsDisplay.PER_MATCH,
        },
      ]}
    />
  );
};
